import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  effect,
  inject,
} from '@angular/core';
import { MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { WINDOW, DOCUMENT } from './search-result.module';
import { LoadingService } from '@shared/services/loading.service';
import { WebengageService } from '@core/services/webengage.service';
import { MomentService } from '@core/services/moment.service';
import { SearchResultBaseClass } from '@core/base/search-result-base';
import { FiltersDialogComponent } from './components/filters-dialog/filters-dialog.component';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { animate, style, transition, trigger } from '@angular/animations';

//declare var webengage: any;

@Component({
  selector: 'iho-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class SearchResultComponent extends SearchResultBaseClass implements OnInit, OnDestroy, AfterViewInit {
  private searchBoxService = inject(SearchBoxService);
  accommodation = this.route.snapshot.data['accommodation'] || 'hotel';
  ecolodge = this.accommodation == 'ecolodge'
  selectedFilterCount: number = 0;
  @Input() mapUrlMain?: string;
  dynamicSlug: string = '';
  mapUrl: string = '';
  minPriceFilterInit!: number | string | undefined;
  maxPriceFilterInit!: number | string | undefined;
  @ViewChild('triggerSticky') triggerSticky!: ElementRef;
  showPlpStickyMenu = false
  sortEnabled = false
  private observer!: IntersectionObserver;
  constructor() {
    super(
      inject(WINDOW),
      inject(DOCUMENT),
      inject(PLATFORM_ID),
      inject(LoadingService), // Removed SVGForeignObjectElement
      inject(WebengageService),
      inject(MomentService),
      inject(RialToTomanPipe)
    );
    this.mapUrl = this.mapUrlEcolodge(this.searchResult?.MapUrl);

    effect(() => {
      if (
        this.searchUiService.isFilterSet() &&
        this.lastFiltersCount !== this.searchUiService.isFilterSet()
      ) {
        this.currentPageIndex = 0;
        this.searchUiService.pageIndex = 0;
        this.searchUiService.fetchedPages = [];
      }
    });

    effect(() => {
      this.nextPageLoading = this.searchUiService.nextPageLoading();
      this.prevPageLoading = this.searchUiService.prevPageLoading();
      this.hasNextPage =
        (this.searchUiService.fetchedPages[this.searchUiService.fetchedPages.length - 1] + 1) *
        this.searchUiService.pageSize <
        this.searchUiService.searchResult()?.PageTitle?.CountHotel && (!this.searchUiService.showPagination());
      this.hasPrevPage = this.searchUiService.fetchedPages[0] - 1 >= 0;

      this.currentPageIndex = !this.currentPageIndex
        ? this.searchUiService.pageIndex
        : this.currentPageIndex;
      this.heightOfWholePage = isPlatformBrowser(this.platformId)
        ? this.window.document.documentElement.scrollHeight
        : 0;
    });

    effect(() => {
      this.queryParams = this.route.snapshot.queryParams;
      this.searchResult = this.searchUiService.searchResult();
      this.cards = this.searchUiService.hotelsList();
      if (this.searchResult.FAQs && this.searchResult.FAQs.length) {
        this.faqs = this.searchResult.FAQs;
      }
      this.plpRelatedLinks = {
        OtherHotels: this.searchResult?.OtherHotels,
        PageGeneratorLinks: this.searchResult?.PageGeneratorLinks,
        PopularHotels: this.searchResult?.PopularHotels,
      };

      if (!this.previousHashKey || this.previousHashKey !== this.searchResult.HashKey) {
        if (this.searchResult.Search && isPlatformBrowser(this.platformId)) {
          this.webEngageService.trackIntrack('Search-result-view', {
            destination: this.searchResult?.Cards[0]?.CardData?.CityName,
            checkInDate: this.momentService.toGergorian(this.searchResult?.Search?.StartDate),
            offerHotelName: this.searchResult?.Cards[0]?.CardData?.FullName,
            offerHotelUrl: this.searchResult?.Cards[0]?.CardData?.HotelUrl,
            hotelType:
              this.searchResult?.Search?.Type == 1
                ? 'هتل'
                : this.searchResult?.Search?.Type == 2
                  ? 'هتل آپارتمان'
                  : this.searchResult?.Search?.Type == 3
                    ? 'بوم گردی'
                    : this.searchResult?.Search?.Type == 4
                      ? 'اقامتگاه'
                      : this.searchResult?.Search?.Type == 5
                        ? 'مهمانپذیر'
                        : this.searchResult?.Search?.Type == 6
                          ? 'واحد مستقل'
                          : '',
            cityUrl: this.searchResult?.Search?.Link,
            numberOfNight: this.searchResult?.Search?.Night,
            urlWithQs: this.searchResult?.Search?.Link,
            checkoutDate: this.momentService.toGergorian(this.searchResult?.Search?.EndDate),
            state: this.searchResult?.Search?.State,
          });
        }

        this.previousHashKey = this.searchResult.HashKey;
        this.filtersData = this.searchResult.FilterBar;
      }

      if (this.currentPageIndex === 0 && isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.window.scrollTo({ top: 0, behavior: 'auto' });
        }, 100);
      }
      if (this.ecolodge && this.filtersData?.length) {

        this.rangeItems = this.filtersData ? this.filtersData?.[1].Items : {};
        this.minPriceValue = this.rangeItems ? +this?.rangeItems?.[0]?.Value : 0;
        this.maxPriceValue = this.rangeItems ? +this?.rangeItems?.[1]?.Value : 0;
        this.residenceItems = this.filtersData ? this?.filtersData?.[2]?.Items : {};
      } else {
        this.rangeItems = this.filtersData ? this.filtersData?.[0].Items : {};
        this.minPriceValue = this.rangeItems ? +this?.rangeItems?.[0]?.Value : 0;
        this.maxPriceValue = this.rangeItems ? +this?.rangeItems?.[1]?.Value : 0;
        this.residenceItems = this.filtersData ? this?.filtersData?.[3]?.Items : {};
      }
    });
    this.minPriceFilterInit = +this.route.snapshot.queryParams['minPrice'];
    this.maxPriceFilterInit = +this.route.snapshot.queryParams['maxPrice'];
    this.sortEnabled = this.route.snapshot.queryParams['sort'] ? true : false

  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.ecolodge) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const isSticky = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
          if (isSticky) {
            this.showPlpStickyMenu = true
          } else {
            this.showPlpStickyMenu = false
          }
        },
        { threshold: [0], rootMargin: '0px' }
      );
      observer.observe(this.triggerSticky.nativeElement);
    }
  }





  goToMap() {
    this.router.navigate([
      !this.ecolodge
        ? '/' + window.location.href.split('/')[3] + '/map'
        : window.location.href.split('/')[3] +
        ('/' + window.location.href.split('/')[4].split('?')[0]) +
        '/map',
    ]);
  }

  selectedItemSortFilter(ev: any) {
    this.router.navigate([], {
      queryParams: {
        ...this.queryParams,
        sort: ev.enVal,
        page: this.ecolodge ? null : 1,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  openRangeTemplate(config?: MatBottomSheetConfig) {
    if (Object.values(this.queryParams)[0] !== undefined) {
      if (this.queryParams['minPrice']) this.minPriceValue = +this.queryParams['minPrice'];
      if (this.queryParams['maxPrice']) this.maxPriceValue = +this.queryParams['maxPrice'];
    }
    this._bottomSheet.open(this.rangeTemplate, config);
  }
  openResidenceTemplate(config?: MatBottomSheetConfig) {
    this._bottomSheet.open(this.residenceTemplate, config);
  }
  MinValue(ev: any) {
    this.minPriceValue = ev;
  }

  MaxValue(ev: any) {
    this.maxPriceValue = ev;
  }

  checkedResidence(ev: any) {
    this.typesFilters = [...new Set(ev.value)].toString();
  }

  getDataForFilters() {
    let params = {};
    this.searchUiService.resetPlpResults();
    if (this.ecolodge) {
      params = {
        minPrice: this.minPriceValue,
        maxPrice: this.maxPriceValue,
        hotelTypes: this.typesFilters,
        page: 1,
      };
    } else {
      params = {
        minPrice: this.minPriceValue,
        maxPrice: this.maxPriceValue,
        types: this.typesFilters,
        page: 1,
      };
    }
    this.router.navigate([], {
      queryParams: {
        ...this.queryParams,
        ...params,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });

    this._bottomSheet.dismiss();
  }

  removeFilters(removeAll: boolean, filterType?: string, filterType2?: string) {
    if (this.ecolodge) filterType = 'hotelTypes';

    this.searchUiService.resetPlpResults();
    if (isPlatformBrowser(this.platformId)) {
      this.window.scrollTo(0, 0);
      this.router.navigate([], {
        queryParams: removeAll
          ? {
            ...this.queryParams,
            minPrice: null,
            maxPrice: null,
            types: null,
            labels: null,
            reviews: null,
            grades: null,
            page: this.ecolodge ? null : 1,
            labelsAccomodate: null,
            hotelTypes: null,
            hotelStyles: null,
            facilities: null,
          }
          : {
            ...this.queryParams,
            [filterType!]: null,
            [filterType2!]: null,
          },
        queryParamsHandling: 'merge',
        relativeTo: this.route,
      });
      this._bottomSheet.dismiss();
      this.currentPageIndex = 0;
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.showSideFilter.set(false);
          this.showPriceFilter.set(false);
        }, 300);

        setTimeout(() => {
          this.showPriceFilter.set(true);
          this.showSideFilter.set(true);
        }, 500);
      }
    }
  }

  FilterCountEmitter(count: number) {
    this.selectedFilterCount = count;
  }
  filterActive(key: string) {
    return this.selectedFilterTitles.some((item: any) => item.key === key)
  }
  filterRemove(key: string): boolean {
    return this.selectedFilterTitles.some((item: any) => item.key === key) ? true : false;
  }
  filterCount(key: string) {
    let find = this.selectedFilterTitles.filter((item: any) => item.key == key);

    if (find.length > 0) {
      return find[0].count > 1 ? find[0].count : '';
    } else {
      return '';
    }
  }
  filterTitle(key: string): string {
    const foundedItemIndex = this.filtersData.findIndex(x => x.Key === key)
    if (foundedItemIndex >= 0) {
      if (key === 'price') {
        let find = this.selectedFilterTitles.filter((item: any) => item.key == key);
        if (find.length > 0) {
          return find[0].Title;
        }
      }
      return this.filtersData[foundedItemIndex].Title
    }
    return ''


  }
  removeFilter(title: string, ev: any) {
    ev.stopPropagation();
    let updatedParams = { ...this.route.snapshot.queryParams };
    if (title == 'price') {
      delete updatedParams['minPrice'];
      delete updatedParams['maxPrice'];
    } else {
      delete updatedParams[title];
    }
    delete updatedParams['page'];
    this.searchUiService.resetPlpResults();
    this.router.navigate([], {
      queryParams: updatedParams,
      relativeTo: this.route,
    });
    this.checkSelectedFilter(updatedParams);

  }


  openFilterDialog(index: number, mobile = false) {
    this.dialog.open(FiltersDialogComponent, {
      data: { dataSource: this.filtersData, expandedIndex: index },
      panelClass: [
        'w-screen',
        'lg:w-[533px]',
        'h-screen',
        '!max-w-full',
        'lg:h-auto',
      ],
      autoFocus: false,
      disableClose: true
    })
  }




  onPaginate(page: number) {
    this.searchUiService.resetPlpResults();
    this.router.navigate([], {
      queryParams: {
        ...this.queryParams,
        page,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 10);
    }

  }
  mapUrlEcolodge(mapUrl: string = '') {
    const cityName = this.route.snapshot.paramMap.get('city-name');
    const countryName = this.route.snapshot.paramMap.get('country');

    let baseRoute = '';

    if (this.accommodation !== 'ecolodge') {
      baseRoute = countryName ? `/${countryName}/${cityName}` : `/${cityName}`;
    } else if (isPlatformBrowser(this.platformId)) {
      const pathParts = window.location.href.split('/');
      const part3 = pathParts[3] || '';
      const part4 = decodeURIComponent(pathParts[4]?.split('?')[0] || '');
      baseRoute = `/${part3}/${part4}`;
    } else {
      // در SSR یه مقدار پیش‌فرض بده یا خالی بذار
      baseRoute = '';
    }

    const search = isPlatformBrowser(this.platformId) ? window.location.search : '';
    return baseRoute + '/map' + search;
  }

  override ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    super.ngOnDestroy();
  }


}
